module.exports = __webpack_public_path__ + "static/media/landingPageImage_md.e264b290.png";